<template>
  <v-app>
    <v-app-bar app flat style="z-index: 101" id="header">
      <v-spacer></v-spacer>
      <div class="d-flex align-center">
        <v-img
          alt="らくのるきやま"
          class="shrink mr-2"
          contain
          :src="require('@/assets/logo.png')"
          transition="scale-transition"
          @click="deleteCookie"
          style="width: 90vw"
        />
      </div>
      <v-spacer></v-spacer>
    </v-app-bar>

    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import store from "./store";
import router from "./vue-router/index";
import Export from "./export";
import axios from "axios";
export default {
  name: "App",
  components: {
    //Map,
    //Client,
  },
  async mounted() {
    this.getNow();
    setInterval(this.getNow, 3000);
    setInterval(this.postDeviceStatus, 10000);
    var getSetting = await Export.getSetting();
    store.state.mail = getSetting.data[0].mail;
    store.state.businessHoursStart = Number(
      getSetting.data[0].businessHoursStart
    );
    store.state.businessHoursEnd = Number(getSetting.data[0].businessHoursEnd);
    store.state.holiday = JSON.parse(getSetting.data[0].holiday);
    store.state.businessDayTxt = getSetting.data[0].businessDayTxt;
    //基山町のみ ここから
    store.state.numbers = JSON.parse(getSetting.data[0].numbers);
    store.state.getCrewsInterval = getSetting.data[0].getCrewsInterval;
    //基山町のみ ここまで
    this.callTimeout = Number(getSetting.data[0].callTimeout);
    this.getIp();
    this.$nextTick(() => {
      var header = document.getElementById("header");
      this.headerHeight = header.offsetHeight;
    });
  },
  data: () => ({
    //
  }),
  computed: {
    dayOfWeek: {
      get() {
        return store.state.dayOfWeek;
      },
      set(value) {
        store.state.dayOfWeek = value;
      },
    },
    dayOfWeekStr: {
      get() {
        return store.state.dayOfWeekStr;
      },
      set(value) {
        store.state.dayOfWeekStr = value;
      },
    },
    businessHoursStart: {
      get() {
        return store.state.businessHoursStart;
      },
      set(value) {
        store.state.businessHoursStart = value;
      },
    },
    businessHoursEnd: {
      get() {
        return store.state.businessHoursEnd;
      },
      set(value) {
        store.state.businessHoursEnd = value;
      },
    },

    hour: {
      get() {
        return store.state.hour;
      },
      set(value) {
        store.state.hour = value;
      },
    },
    minute: {
      get() {
        return store.state.minute;
      },
      set(value) {
        store.state.minute = value;
      },
    },
    driverMode: {
      get() {
        return store.state.driverMode;
      },
      set(value) {
        store.state.driverMode = value;
      },
    },
    callTimeout: {
      get() {
        return store.state.callTimeout;
      },
      set(value) {
        store.state.callTimeout = value;
      },
    },
    currentBusStopId: {
      get() {
        return store.state.currentBusStopId;
      },
      set(value) {
        store.state.currentBusStopId = value;
      },
    },
    currentMobilityId: {
      get() {
        return store.state.currentMobilityId;
      },
      set(value) {
        store.state.currentMobilityId = value;
      },
    },
    ip: {
      get() {
        return store.state.ip;
      },
      set(value) {
        store.state.ip = value;
      },
    },
    headerHeight: {
      get() {
        return store.state.headerHeight;
      },
      set(value) {
        store.state.headerHeight = value;
      },
    },
    numbers: {
      get() {
        return store.state.numbers;
      },
      set(value) {
        store.state.numbers = value;
      },
    },
    getCrewsInterval: {
      get() {
        return store.state.getCrewsInterval;
      },
      set(value) {
        store.state.getCrewsInterval = value;
      },
    },
  },
  watch: {
    hour() {
      if (this.hour == this.businessHoursStart && this.driverMode == true) {
        router.push("/standby");
        this.$nextTick(() => {
          router.push("/driver");
        });
      }
    },
  },
  methods: {
    getNow() {
      var date = new Date();
      //var year = date.getFullYear(); // 年
      //var month = date.getMonth() + 1; // 月
      //var day = date.getDate(); // 日
      var hour = date.getHours(); // 時
      var minute = date.getMinutes(); // 分
      //var second = date.getSeconds(); // 秒
      var dayOfWeek = date.getDay(); // 曜日(数値)
      var dayOfWeekStr = ["日", "月", "火", "水", "木", "金", "土"][dayOfWeek]; // 曜日(日本語表記)
      this.dayOfWeek = dayOfWeek;
      this.dayOfWeekStr = dayOfWeekStr;
      this.hour = hour;
      this.minute = minute;
    },
    deleteCookie() {
      this.$cookies.remove("currentBusStopId");
      this.$cookies.remove("currentMobilityId");
      this.$cookies.remove("driverMode");
      this.$cookies.remove("homeLat");
      this.$cookies.remove("homeLon");
    },
    async postDeviceStatus() {
      var timestamp = Date.now();
      let formdata = new URLSearchParams();
      formdata.append("busStopId", this.currentBusStopId);
      formdata.append("mobilityId", this.currentMobilityId);
      formdata.append("currentPage", this.$route.name);
      formdata.append("timestamp", timestamp);
      formdata.append("driverMode", this.driverMode);
      formdata.append("ip", this.ip);
      await Export.postDeviceStatus(formdata);
    },
    getIp() {
      axios
        .post("https://ipinfo.io/")
        .then((e) => {
          this.ip = e.data.ip;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>
<style>
.v-app-bar {
  background: #333 !important;
  color: #fff !important;
}
body {
  -webkit-touch-callout: none;
  user-select: none;
}
#header {
  background: #58a23c !important;
}
</style>
